// extracted by mini-css-extract-plugin
export default {"like_btn_active":"Like_like_btn_active__mI9s2","like_btn":"Like_like_btn__fxVWB"};